import React from "react";
import { Button } from "reactstrap";

// labels
import { LB_WL_VIEW_MINUS, LB_WL_VIEW_MORE } from "../../i18n/i18n";

const HeaderButtonComponent = ({
   isCollapsed = true,
   onClick = () => console.warn('With out action'),
})=> {

    return <Button
        className={'link'}
        color={'link'}
        type={'button'}
        onClick={ onClick }
    >
        {
            isCollapsed
                ? <><i className={'fa fa-plus'} aria-hidden="true"/> {LB_WL_VIEW_MORE}</>
                : <><i className={'fa fa-minus'} aria-hidden="true"/> {LB_WL_VIEW_MINUS}</>
        }
    </Button>
}

export default HeaderButtonComponent